import React, { useState, useEffect, createRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./verifyotp.scss";
import Button from "components/Button/index";
// import Success from "components/success/index";

// import mailSent from "assets/images/success/mailSent.svg";
import { signupContext } from "context/SignupContext";
// import Success from "components/success/index";
// import { URL } from "URL/url";
import { useToast } from "components/Toaster/index";
const VerifyOtp = ({
  nextStep,
  setOrgUserSuccess = () => { },
  setStep = () => { },
  invite = false,
  setSigninSuccess = () => { },
  onlyTotp = false,
  setIndividualSuccessState,
  selectedQuestions,
  answers,
  setCanGoNext
}) => {
  const navigate = useNavigate();
  // const location = useLocation();
  // const navigate = useNavigate();
  // const [success] = useState(false);
  const { isTypeSelect, user, orgnization, setCouponEmail } = useContext(signupContext);
  const [emailOtp, setEmailOtp] = useState(Array(6).fill(""));
  const [authAppOtp, setAuthAppOtp] = useState(Array(6).fill(""));
  const [isError, setIsError] = useState({ emailotp: false, totp: false });
  const showToast = useToast();
  // const EMAIL_OTP = "123456";
  // const AUTH_APP_OTP = "654321";
  const emailRefs = Array(6)
    .fill(0)
    .map(() => createRef());
  const authAppRefs = Array(6)
    .fill(0)
    .map(() => createRef());

  // const handleChange = (val, idx, otpType) => {
  //   if (isNaN(val)) return;

  //   const newOtp = otpType === "email" ? [...emailOtp] : [...authAppOtp];
  //   newOtp[idx] = val;

  //   otpType === "email" ? setEmailOtp(newOtp) : setAuthAppOtp(newOtp);

  //   if (val && idx < 5) {
  //     (otpType === "email" ? emailRefs : authAppRefs)[idx + 1].current.focus();
  //   }
  // };
  const isDigit=(k)=>/^[0-9]$/.test(k);
  const handleChange = (val, idx, otpType) => {
    if (!/^\d{0,2}$/.test(val)) return; // Allow 0 to 2 digits only

    const lastDigit = val.slice(-1); // Always take the last digit

    const otp = otpType === "email" ? [...emailOtp] : [...authAppOtp];
    const setOtp = otpType === "email" ? setEmailOtp : setAuthAppOtp;
    const refs = otpType === "email" ? emailRefs : authAppRefs;

    otp[idx] = lastDigit;
    setOtp(otp);

    if (otpType === "email" && isError.emailotp) {
      setIsError((prev) => ({ ...prev, emailotp: false }));
    } else if (otpType === "authApp" && isError.totp) {
      setIsError((prev) => ({ ...prev, totp: false }));
    }
    if (lastDigit && idx < refs.length - 1 && refs[idx + 1]?.current) {
      refs[idx + 1].current.focus();
    }
  };

  
  const handlePaste = (e, idx, otpType) => {
    e.preventDefault();
    const pastedData = (e.clipboardData || window.clipboardData).getData("text");
    const digits = pastedData.replace(/\D/g, "").slice(0, 6); // Extract only digits, max 6
    
    if (!digits) return;

    const otp = otpType === "email" ? [...emailOtp] : [...authAppOtp];
    const setOtp = otpType === "email" ? setEmailOtp : setAuthAppOtp;
    const refs = otpType === "email" ? emailRefs : authAppRefs;

    // Fill OTP fields starting from the current index
    for (let i = 0; i < digits.length && (idx + i) < refs.length; i++) {
      otp[idx + i] = digits[i];
      if (refs[idx + i]?.current) {
        refs[idx + i].current.value = digits[i];
      }
    }

    setOtp(otp);

    // Clear error state
    if (otpType === "email" && isError.emailotp) {
      setIsError((prev) => ({ ...prev, emailotp: false }));
    } else if (otpType === "authApp" && isError.totp) {
      setIsError((prev) => ({ ...prev, totp: false }));
    }

    // Focus the next empty field or the last field if all are filled
    const nextEmptyIdx = otp.findIndex((digit, i) => i >= idx && digit === "");
    const focusIdx = nextEmptyIdx !== -1 ? nextEmptyIdx : Math.min(idx + digits.length, refs.length - 1);
    // Validate focusIdx is within bounds before attempting to focus
    if (focusIdx >= 0 && focusIdx < refs.length && refs[focusIdx]?.current) {
      setTimeout(() => {
        // Double-check the ref is still valid before focusing
        if (focusIdx >= 0 && focusIdx < refs.length && refs[focusIdx]?.current) {
          try {
            refs[focusIdx].current.focus();
          } catch (error) {
            console.warn("Failed to focus OTP input:", error);
          }
        }
      }, 0);
    }
  };

  const handleKeyDown = (e, idx, otpType) => {
    // console.log(e.key, "key pressed");
    const otp = otpType === "email" ? emailOtp : authAppOtp;
    const refs = otpType === "email" ? emailRefs : authAppRefs;
    const setOtp = otpType === "email" ? setEmailOtp : setAuthAppOtp;

    if(isDigit(e.key)){
      e.preventDefault();

      const newOtp = [...otp];
      newOtp[idx] = e.key; // Set the digit directly
      setOtp(newOtp);
      if (refs[idx]?.current) {
        refs[idx].current.value = e.key;
      }

      if(idx < refs.length -1 && refs[idx+1]?.current) {
        refs[idx+1].current.focus();
      }
      if(otpType === "email" && isError.emailotp) 
        setIsError((prev) => ({ ...prev, emailotp: false }));
      else if (otpType === "authApp" && isError.totp) 
        setIsError((prev) => ({ ...prev, totp: false }));
      return;

    }
  
    if (e.key === "Backspace") {
      e.preventDefault();
  
      const newOtp = [...otp];
      if (otp[idx]) {
        // If there's a digit, delete it
        newOtp[idx] = "";
        setOtp(newOtp);
      } else if (idx > 0 && refs[idx - 1]?.current) {
        // If field is empty and it's not the first field, move focus to the previous field
        newOtp[idx - 1] = "";
        setOtp(newOtp);
        const prevInput = refs[idx - 1].current;
        prevInput.focus();
        // Ensure cursor is at the end of the previous field
        setTimeout(() => {
          if (refs[idx - 1]?.current) {
            refs[idx - 1].current.setSelectionRange(refs[idx - 1].current.value.length, refs[idx - 1].current.value.length);
          }
        }, 0); // Use timeout to ensure the DOM has updated
      }
    }
  
    if (e.key === "ArrowLeft" && idx > 0 && refs[idx - 1]?.current) {
      e.preventDefault();
      // Move focus to the previous input field and set the cursor at the end
      const prevInput = refs[idx - 1].current;
      prevInput.focus();
      setTimeout(() => {
        if (refs[idx - 1]?.current) {
          refs[idx - 1].current.setSelectionRange(refs[idx - 1].current.value.length, refs[idx - 1].current.value.length);
        }
      }, 0); // Ensure the cursor is at the end
    }
  
    if (e.key === "ArrowLeft" && idx === 0 && refs[0]?.current) {
      e.preventDefault();
      // Prevent cursor from jumping to the left of the first input field
      const firstInput = refs[0].current;
      firstInput.focus();
      setTimeout(() => {
        if (refs[0]?.current) {
          refs[0].current.setSelectionRange(refs[0].current.value.length, refs[0].current.value.length);
        }
      }, 0); // Ensure the cursor is at the end
    }
  
    if (e.key === "ArrowRight" && idx < refs.length - 1 && refs[idx + 1]?.current) {
      e.preventDefault();
      // Move focus to the next input field and set the cursor at the end
      const nextInput = refs[idx + 1].current;
      nextInput.focus();
      setTimeout(() => {
        if (refs[idx + 1]?.current) {
          refs[idx + 1].current.setSelectionRange(refs[idx + 1].current.value.length, refs[idx + 1].current.value.length);
        }
      }, 0); // Ensure the cursor is at the end
    }
  
    if (e.key === "Enter") {
      const isEmailComplete = emailOtp.every((digit) => digit !== "");
      const isAuthComplete = authAppOtp.every((digit) => digit !== "");
      if ((isEmailComplete || onlyTotp) && isAuthComplete) {
        verifyOtp();
      }
    }
  };

  useEffect(() => {
    const isEmailComplete = emailOtp.every((digit) => digit !== "");
    const isAuthComplete = authAppOtp.every((digit) => digit !== "");
    const isComplete = (isEmailComplete || onlyTotp) && isAuthComplete;
    if (setCanGoNext) setCanGoNext(isComplete);
  }, [emailOtp, authAppOtp, onlyTotp, setCanGoNext]);
  

  
  

  const verifyOtp = async () => {
    const mailOtp = emailOtp.join("");
    const authOtp = authAppOtp.join("");

    if (!onlyTotp) {

      if (isTypeSelect !== "individual") {
        try {
          setIsError(false);
          await orgnization.verify(mailOtp, authOtp,selectedQuestions, answers);
          nextStep();
          // Success state should only be set after successful payment, not here
        } catch (error) {
          // setIsError(true);
          const errorMsg = error.message?.toLowerCase() || "";
          if (errorMsg.includes("503") || errorMsg.includes("maintenance") || errorMsg.includes("failed to fetch")) {
            navigate("/maintenance");
          } else {
            if (errorMsg.includes("email")) {
              setIsError({ emailotp: true });
            } else if (errorMsg.includes("totp")) {
              setIsError({ totp: true });
            }
            showToast(error.message, "error");
          }
        }
      } else {

        try {

          await user.verify(mailOtp, authOtp,selectedQuestions,answers);

          if (!invite) {
            // setSuccess(true);
            
             setSigninSuccess(true);
             // Success state should only be set after payment or free plan selection, not here
            nextStep();
          } else {
            setSigninSuccess(true);
            setStep("");
            
          }
        } catch (error) {
          // setIsError(true);
          const errorMsg = error.message?.toLowerCase() || "";
          if (errorMsg.includes("503") || errorMsg.includes("maintenance") || errorMsg.includes("failed to fetch")) {
            navigate("/maintenance");
          } else {
            if (errorMsg.includes("email")) {
              setIsError({ emailotp: true });
            } else if (errorMsg.includes("totp")) {
              setIsError({ totp: true });
            }
            showToast(error.message, "error");
          }
        }
      }
    } 
  };

  // Store sign-in/sign-up mail in context for coupon flow (Payment uses it). No UI.
  useEffect(() => {
    if (!setCouponEmail) return;
    const mail =
      (user && typeof user.getEmail === "function" && user.getEmail()) ||
      (orgnization && typeof orgnization.getEmail === "function" && orgnization.getEmail()) ||
      "";
    setCouponEmail(mail || "");
    if (mail) {
      console.log("📧 couponEmail set for coupon flow (from OtpScreen):", mail);
    }
  }, [user, orgnization, setCouponEmail]);

  useEffect(() => {
    if (emailRefs[0]?.current) {
      emailRefs[0].current.focus();
    }
  }, []);

  // const signinHandler = () => {
  //   navigate("/signin");
  // };
  return (
    <>
      {onlyTotp ? (
        <section className="verify">
          <div className="container verifyContainer">
            <div className="verifyBox">
              <div className="verifyCodeBox">
                <div className="commonHeading" style={{ marginBottom: "14px" }}>
                  <h1>Authentication App Verification</h1>
                  <p>Enter the six-digit code from your authentication app.</p>
                </div>
                <div className="otpContainer">
                  <div className="inputsWrapper" id="authenticateOtp">
                    {authAppOtp.map((digit, idx) => (
                      <input
                        key={idx}
                        ref={authAppRefs[idx]}
                        maxLength={1}
                        value={digit}
                        onChange={(e) =>
                          handleChange(e.target.value, idx, "authApp")
                        }
                        onKeyDown={(e) => handleKeyDown(e, idx, "authApp")}
                        onPaste={(e) => handlePaste(e, idx, "authApp")}
                       // onFocus={(e) => e.target.select()}
                       onFocus={(e) => {
                          const input = e.target;
                          input.setSelectionRange(input.value.length, input.value.length);
                        }} 
                        style={{
                          border: isError?.totp
                            ? "1px solid var(--accent-colors-red)"
                            : ""
                        }}
                        inputMode="numeric"
                      />
                    ))}
                  </div>
                </div>
                <span
                  style={{ visibility: isError?.totp ? "visible" : "hidden" }}
                  className="errorText"
                >
                  Please enter valid codes
                </span>
                <Button
                  title="Verify Code"
                  type="violet"
                  onClick={verifyOtp}
                  disabled={
                    emailOtp.some((digit) => digit === "") ||
                    authAppOtp.some((digit) => digit === "")
                  }
                />

              </div>
            </div>
          </div>
        </section>

      ) : (
        <section className="verify">
          <div className="container verifyContainer">
            <div className="verifyBox">
              <div className="commonHeading">
                <h1>Email Verification</h1>
                <p>Enter the six-digit code sent to your email.</p>
              </div>
              <div className="verifyCodeBox">
                <div className="otpContainer">
                  <div
                    className="inputsWrapper"
                    style={{ marginBottom: "10px" }}
                    id="emailOtp"
                  >
                    {emailOtp.map((digit, idx) => (
                      <input
                        key={idx}
                        ref={emailRefs[idx]}
                        maxLength={1}
                        value={digit}
                        onChange={(e) =>
                          handleChange(e.target.value, idx, "email")
                        }
                        onKeyDown={(e) => handleKeyDown(e, idx, "email")}
                        onPaste={(e) => handlePaste(e, idx, "email")}
                        // onFocus={(e) => e.target.select()}
                        style={{
                          border: isError?.emailotp
                            ? "1px solid var(--accent-colors-red)"
                            : ""
                        }}
                        inputMode="numeric"
                      />
                    ))}
                  </div>
                  <span
                    style={{
                      visibility: isError?.emailotp ? "visible" : "hidden",
                      textAlign: "center"
                    }}
                    className="errorText"
                  >
                    Please enter valid codes
                  </span>
                </div>
                <div className="commonHeading" style={{ marginBottom: "14px" }}>
                  <h1>Authentication App Verification</h1>
                  <p>Enter the six-digit code from your authentication app.</p>
                </div>
                <div className="otpContainer">
                  <div className="inputsWrapper" id="authenticateOtp">
                    {authAppOtp.map((digit, idx) => (
                      <input
                        key={idx}
                        ref={authAppRefs[idx]}
                        maxLength={1}
                        value={digit}
                        onChange={(e) =>
                          handleChange(e.target.value, idx, "authApp")
                        }
                        onKeyDown={(e) => handleKeyDown(e, idx, "authApp")}
                        onPaste={(e) => handlePaste(e, idx, "authApp")}
                        style={{
                          border: isError?.totp
                            ? "1px solid var(--accent-colors-red)"
                            : ""
                        }}
                        inputMode="numeric"
                      />
                    ))}
                  </div>
                </div>
                <span
                  style={{ visibility: isError?.totp ? "visible" : "hidden" }}
                  className="errorText"
                >
                  Please enter valid codes
                </span>
                <Button
                  title="Verify Code"
                  type="violet"
                  onClick={verifyOtp}
                  disabled={
                    emailOtp.some((digit) => digit === "") ||
                    authAppOtp.some((digit) => digit === "")
                  }
                />

              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default VerifyOtp;

// import React, { createRef, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import "./verifyotp.scss";
// import Button from "components/Button/index";
// // import Success from "components/success/index";

// import init, { IzWasm } from "Wasm/izwasm.js";
// import { useToast } from "components/Toaster/index";
// import { signupContext } from "context/SignupContext";
// import Success from "components/success/index";
// const VerifyOtp = ({
//   nextStep,
//   setOrgUserSuccess = () => { },
//   setStep = () => { },
//   userData,
//   invite = false,
//   setSigninSuccess = () => { }
// }) => {
//   const navigate = useNavigate();
//   const [success, setSuccess] = useState(false);
//   const { formData, isTypeSelect } = useContext(signupContext);
//   const [emailOtp, setEmailOtp] = useState(Array(6).fill(""));
//   const [authAppOtp, setAuthAppOtp] = useState(Array(6).fill(""));
//   const [isError, setIsError] = useState(false);
//   const showToast = useToast();
//   // const EMAIL_OTP = "123456";
//   // const AUTH_APP_OTP = "654321";
//   const emailRefs = Array(6)
//     .fill(0)
//     .map(() => createRef());
//   const authAppRefs = Array(6)
//     .fill(0)
//     .map(() => createRef());

//   const handleChange = (val, idx, otpType) => {
//     if (isNaN(val)) return;

//     const newOtp = otpType === "email" ? [...emailOtp] : [...authAppOtp];
//     newOtp[idx] = val;

//     otpType === "email" ? setEmailOtp(newOtp) : setAuthAppOtp(newOtp);

//     if (val && idx < 5) {
//       (otpType === "email" ? emailRefs : authAppRefs)[idx + 1].current.focus();
//     }
//   };

//   const handleKeyDown = (e, idx, otpType) => {
//     if (
//       e.key === "Backspace" &&
//       idx > 0 &&
//       (otpType === "email" ? !emailOtp[idx] : !authAppOtp[idx])
//     ) {
//       (otpType === "email" ? emailRefs : authAppRefs)[idx - 1].current.focus();
//     }
//   };

//   const verifyOtp = async () => {
//     await init();
//     const mailOtp = emailOtp.join("");
//     const authOtp = authAppOtp.join("");
//     const wasmInstance = new IzWasm(URL);
//     if (isTypeSelect !== "individual") {
//       try {
//         setIsError(false);
//         const verifyOrg = await wasmInstance.verify_orgnization(
//           formData.email,
//           formData.name,
//           mailOtp,
//           authOtp
//         );
//         console.log("Organization verified:", verifyOrg, nextStep);
//         if (verifyOrg && isTypeSelect !== "individual") {
//           // setSuccess(true);
//           // navigate("/organizationprofile");
//           nextStep();
//         } else {
//           setSuccess(true);
//         }
//       } catch (error) {
//         console.log(error, "error");
//         showToast(error.message, "error");
//       }
//     } else {
//       if (invite) {
//         try {
//           const verifyUser = await wasmInstance.verify_user(
//             userData?.email,
//             userData?.name,
//             mailOtp,
//             authOtp
//           );
//           if (verifyUser) {
//             setSigninSuccess(true);
//             setStep("");
//             setOrgUserSuccess(true);
//           } else {
//             console.log("failed to signup");
//           }
//         } catch (error) {
//           console.log(error, "error");
//           showToast(error.message, "error");
//         }
//       } else {
//         try {
//           const verifyUser = await wasmInstance.verify_user(
//             formData.email,
//             formData.name,
//             mailOtp,
//             authOtp
//           );
//           if (verifyUser && formData.name === "") {
//             // setSuccess(true);
//             nextStep();
//           } else {
//             setStep("");
//             setOrgUserSuccess(true);
//           }
//         } catch (error) {
//           console.log(error, "error");
//           showToast(error.message, "error");
//         }
//       }
//     }
//   };

//   useEffect(() => {
//     emailRefs[0].current.focus();
//   }, []);

//   const signinHandler = () => {
//     navigate("/signin");
//   };

//   return (
//     <>
//       {
//         success ? (
//           <Success
//           title={"Account Created Successfully"}
//                     titleWidth="75.7%"
//                     titleMobileWidth="100%"
//                     subTitle={
//                       "Your account has been successfully signed up. Enjoy exploring our services!"
//                     }
//                     subTitleWidth="85.2%"
//                     subTitleMobileWidth="100%"
//                     buttonText={"Sign in"}
//                     image=""
//                     imgWidth="80px"
//                     imgHeight="80px"
//                     onClick={signinHandler}
//                     success={true}
//           />
//         ): (
//           <section className = "verification">
//         <div className = "container verifysContainer">
//           <div className = "verificationBox">
//             <div className = "otpContainer" id = "emailOtp">
//               <div className = "headingContainer">
//                 <h1>Email verification</h1 >
//     <p>Enter the six digit code sent to you email.</p>
//               </div >
//   <div className="inputsWrapper">
//     {emailOtp.map((digit, idx) => (
//       <input
//         key={idx}
//         ref={emailRefs[idx]}
//         maxLength={1}
//         value={digit}
//         onChange={(e) =>
//           handleChange(e.target.value, idx, "email")
//         }
//         onKeyDown={(e) => handleKeyDown(e, idx, "email")}
//         style={{
//           border: isError
//             ? "1px solid var(--accent-colors-red)"
//             : ""
//         }}
//         inputMode="numeric"
//         placeholder="0"
//       />
//     ))}
//   </div>
//             </div >
//             <div className="otpContainer" id="authenticateOtp">
//               <div className="headingContainer">
//                 <h1>Authentication app verification</h1>
//                 <p>Enter the six digit code from the authentication application</p>
//               </div>
//               <div className="inputsWrapper">
//                 {authAppOtp.map((digit, idx) => (
//                   <input
//                     key={idx}
//                     ref={authAppRefs[idx]}
//                     maxLength={1}
//                     value={digit}
//                     onChange={(e) =>
//                       handleChange(e.target.value, idx, "authApp")
//                     }
//                     onKeyDown={(e) => handleKeyDown(e, idx, "authApp")}
//                     style={{
//                       border: isError
//                         ? "1px solid var(--accent-colors-red)"
//                         : ""
//                     }}
//                     inputMode="numeric"
//                     placeholder="0"
//                   />
//                 ))}
//               </div>
//             </div>
//             <Button title="Verify code" type="violet"
//               onClick={verifyOtp}
//               disabled={
//                 emailOtp.some((digit) => digit === "") ||
//                 authAppOtp.some((digit) => digit === "")
//               }
//             />
//           </div >
//         </div >
//       </section >
//       )
//     }
//     </>
//   );
// };

// export default VerifyOtp;
